import { Route, Routes } from 'react-router-dom';
import { TaxesPage } from './TaxesPage';
import { ModifyTaxPage } from './ModifyTaxPage';

export const TaxPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyTaxPage />} />
    <Route path='/:taxID' element={<ModifyTaxPage />} />
    <Route path='*' element={<TaxesPage />} />
  </Routes>
);
